import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import DashboardLayout from 'components/templates/DashboardLayout/DashboardLayout';
import { getGlobalItemsGroup, getMyGlobalItemsGroup } from 'store/myItems/store/selectors';
import { restartGlobalSearch } from 'store/globalSearch/actions';
import useAction from 'hooks/useAction';
import { getQueryParam } from 'functions/urlHelpers';
import { QUERY_PARAMS } from 'consts/queryParams';
import useGlobalSearchRetailers from 'hooks/useGlobalSearchRetailers';
import useLoadLists from 'hooks/useLoadLists';
import { PATHS } from 'consts/paths';
import checkIsGlobalSearchQueryValid from 'functions/checkIsGlobalSearchQueryValid';
import GlobalSearchSuccessResultsContainer from 'components/organisms/GlobalSearchSuccessResultsContainer/GlobalSearchSuccessResultsContainer';
import GlobalSearchEmptyStateContainer from 'components/organisms/GlobalSearchEmptyStateContainer/GlobalSearchEmptyStateContainer';
import { referralSourceContextProvider } from 'contexts/ReferralSourceContext';
import { REF_SOURCES } from 'consts/referralSources';
import GlobalSearchSkeletonLoader from 'components/organisms/GlobalSearchSkeletonLoader/GlobalSearchSkeletonLoader';

const GlobalSearchResultsPage = () => {
  const query = getQueryParam(QUERY_PARAMS.query);

  const history = useHistory();
  const restartGlobalSearchFunc = useAction(restartGlobalSearch);

  const { retailers, isLoaded: isRetailersLoaded } = useGlobalSearchRetailers(query);

  const globalItemsGroup = useSelector(getGlobalItemsGroup);
  const myGlobalItemsGroup = useSelector(getMyGlobalItemsGroup);

  const myGlobalItems = myGlobalItemsGroup.tags;
  const globalItems = globalItemsGroup.tags;

  const loaded = !!(globalItemsGroup.loaded && myGlobalItemsGroup.loaded && isRetailersLoaded);
  const isEmpty = !!(!myGlobalItems?.length && !globalItems?.length && !retailers?.length);

  const showLoader = !loaded;
  const showEmptyState = loaded && isEmpty;
  const showContent = loaded && !isEmpty;

  useLoadLists();

  useEffect(() => {
    if (checkIsGlobalSearchQueryValid(query)) {
      restartGlobalSearchFunc();
    }
  }, [query]);

  useEffect(() => {
    if (!checkIsGlobalSearchQueryValid(query)) {
      history.push(PATHS.HOME);
    }
  }, []);

  return (
    <DashboardLayout
      title="app:headerGlobalSearch"
      titleProps={{
        query,
      }}
      sendPageView={false}
    >
      {showLoader && <GlobalSearchSkeletonLoader />}
      {showEmptyState && <GlobalSearchEmptyStateContainer />}
      {showContent && <GlobalSearchSuccessResultsContainer retailers={retailers} />}
    </DashboardLayout>
  );
};

export default referralSourceContextProvider(REF_SOURCES.globalSearch)(GlobalSearchResultsPage);
